<template>
    <div class="dashboard__section">
        <h2 class="dashboard__heading">
            <strong>{{ newsletters.length }}</strong>
            {{ newsletters.length | inflection(['odběratel', 'odběratelé', 'odběratelů']) }}
        </h2>
        <div class="dashboard__content" v-if="newsletters.length">
            <h3 class="dashboard__subheading">Poslední odběratelé</h3>

            <ul class="dashboard__list">
                <li class="dashboard__item" v-for="newsletter in newsletters.slice(0, 10)">
                    {{ newsletter.email }}
                    <span class="text--info"
                          v-bind:class="{'text--info': newsletter.optedIn, 'text--maroon': !newsletter.optedIn}">
                        {{ newsletter.optedIn ? 'potvrzen' : 'nepotvrzen' }}
                    </span>
                </li>
            </ul>
        </div>

        <router-link :to="{ name: 'project-customer-newsletter'}" class="text--maroon"><strong>Přejít na seznam
            odběratelů</strong></router-link>
    </div>
</template>
<script>
export default {
    computed: {
        newsletters() {
            return this.$store.getters['projects/project/customer/newsletter/newsletters'];
        }
    },
    mounted() {
        this.$store.dispatch('projects/project/customer/newsletter/loadNewsletters');
    }
}
</script>
